import React, { useContext, useEffect, useRef, useState } from 'react'
import './Khatevahi.css'
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { Document, Page, Text, View, StyleSheet, PDFViewer, Image } from '@react-pdf/renderer';
import { Font } from '@react-pdf/renderer';
import LatoItalicFont from "../../Fonts/Baloo2-VariableFont_wght.ttf";
import Logo from "../../imgs/dairylogo.png";
import back from "../../imgs/backexam.png";
import { useNavigate } from 'react-router-dom';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { Language, YoutubeSearchedForOutlined } from '@material-ui/icons';
import khadya from "../../imgs/khadya.png";
import cash from "../../imgs/cash.png";
import { UilEditAlt, UilEye, UilSetting } from '@iconscout/react-unicons'

import { useTranslation } from "react-i18next";

const Khatevahi = (props) => {
    const { t } = useTranslation();

    const [input, setInput] = useState({
        date1: new Date().toISOString().substr(0, 10),
        date2: new Date().toISOString().substr(0, 10),
        kno: "",
        kname: "",
        lastkhadya: "",
        lastadv: "",
        lastdate: "",
        dno: "",
        name: "",
        khname: "",
        searchsank: "",
        headname: "",
        khname: ""
    });

    const inputRefs = useRef([]);
    const [DataSource, setDataSource] = useState([]);
    const [tableFilter, setTableFilter] = useState([]);
    const [DataSourcekh, setDataSourcekh] = useState([]);
    const [DataSourceadv, setDataSourceadv] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [print, setprint] = useState(false);
    const cellRefs = useRef([]);
    const [value, setValue] = useState('');
    const [partyData, setPartydata] = useState([]);
    const [PreviousAmt, setPreviousAmt] = useState();
    const notify = (msg) => toast(msg);
    const notifyerror = (msg) => toast.error(msg);
    const [customerData, setCustomerData] = useState([]);
    const [khrtype, setKhrtype] = useState("khpur");
    const navigate = useNavigate();
    const refprint = useRef(null);
    const [khnames, setKhnames] = useState([]);
    const refprintclose = useRef(null);
    const [mobileusers, setMobileusers] = useState([]);
    const [wait, setWait] = useState(false);

    const handlertype = (type) => {
        setKhrtype(type)
    }

    useEffect(() => {
        setDataSource([]);
    }, [khrtype])

    const handleprintclose = () => {
        if (refprintclose?.current) refprintclose.current.click();
    }

    function handleEnterKey(event, currentIndex) {
        if (event.keyCode === 8) {
            if (event.target.name === "time") {
                setInput((prevInputSettings) => ({
                    ...prevInputSettings,
                    time: '',
                }));
            }
            else if (event.target.name === "type") {
                setInput((prevInputSettings) => ({
                    ...prevInputSettings,
                    type: '',
                }));
            }
        }

        if (event.key === 'Enter' || event.key === "Tab") {
            event.preventDefault();
            let nextIndex = null;

            if (currentIndex === 2) {
                if (input.name !== "") nextIndex = currentIndex + 1;
                else nextIndex = currentIndex;
            } else {
                nextIndex = currentIndex + 1;
            }

            if (inputRefs.current[nextIndex]) {
                inputRefs.current[nextIndex].focus();
            }
        }
    }

    const filteData = (e) => {
        const searchValue = e.target.value.trim();

        if (searchValue !== "") {
            setValue(searchValue);
            const filtertable = DataSource.filter(o => String(o.kno) === searchValue);
            setTableFilter([...filtertable]);
        } else {
            setValue(searchValue);
            setTableFilter([...DataSource]);
        }
    };

    const filteDataold = (e) => {
        if (e.target.value !== "") {
            setValue(e.target.value);
            const filtertable = DataSource.filter(o => Object.keys(o).some(k =>
                String(o[k]).toLowerCase().includes(e.target.value.toLowerCase())
            ));
            setTableFilter([...filtertable]);
        }
        else {
            setValue(e.target.value);
            setTableFilter([...DataSource]);
        }
    }

    const showprint = () => {
        if (DataSource && DataSource.length > 0) {
            localStorage.setItem("date1print", input.date1);
            localStorage.setItem("date2print", input.date2);
            localStorage.setItem("knoprint", input.dno);
            localStorage.setItem("khate", input.name);

            const url = "/khatevahiprint";
            window.open(url, '_blank');
        }
        else {
            notifyerror(t("Khatevahi.toast.noDataForPeriod"));
        }
    }

    const handleChange = async (event) => {
        const name = event.target.name;
        let valuecurrent = event.target.value;

        setInput(value => ({ ...value, [name]: valuecurrent }));

        if (name === 'date2') {
            const date1 = new Date(input.date1);
            const date2 = new Date(valuecurrent);
            const differenceInDays = (date2 - date1) / (1000 * 60 * 60 * 24);

            // if (differenceInDays <= 30) {
            setInput((prevInput) => ({ ...prevInput, [name]: valuecurrent }));
            // } else {
            //     notifyerror(t("Khatevahi.toast.reportLimitOneMonth"));
            //     setInput((prevInput) => ({ ...prevInput, [name]: new Date().toISOString().substr(0, 10) }));
            // }
        }
    }

    const getkhpurreport = () => {
        setValue("");
        setWait(true);

        var mainuser2 = jsEncode.encode("mamapr", 125);
        let landingphp = "getkhatevahi.php";

        let rawData = {
            date1: input.date1,
            date2: input.date2,
            kno: input.dno,
            mainuser: localStorage.getItem("contact"),
            mainuser2: mainuser2,
        }

        rawData = JSON.stringify(rawData);
        let formData = new FormData();
        formData.append('data', rawData);

        axios.post(`https://excellentdairy.com/dairy/php/cust/${landingphp}`, formData, {
            'Content-Type': 'multipart/form-data',
        }).then(function sample(response) {
            if (response.data && response.data.length > 0) {
                setDataSource(response.data);

                if (khrtype === "dreport") {
                    setPreviousAmt(response.data[0].previousamt);
                }

                setWait(false);
            }
            else {
                notifyerror(t("Khatevahi.toast.noData"));
                setDataSource([]);
                setWait(false);
            }
        }).catch(err => {
            console.log(err);
            setWait(false);
        });
    }

    const getudharidetails = () => { }

    function formatDate(inputDate) {
        if (inputDate) {
            const parts = inputDate.split('-');
            if (parts.length !== 3) return '';

            const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            const month = parseInt(parts[1]) - 1;
            const day = parts[2];

            return `${day}-${months[month]}`;
        }
    }

    function formatDatefull(inputDate) {
        if (inputDate) {
            const parts = inputDate.split('-');
            if (parts.length !== 3) return '';

            const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            const year = parts[0];
            const month = parseInt(parts[1]) - 1;
            const day = parts[2];

            return `${day}-${months[month]} -${year}`;
        }
    }

    const showDetails = (kno, cname, lastadv, lastkhadya, lastdate) => {
        setWait(true);

        var mainuser2 = jsEncode.encode("mamapr", 125);
        let landingphp = "getudharidetails2.php";

        let rawData = {
            date1: input.date1,
            date2: input.date2,
            kno: kno,
            mainuser: localStorage.getItem("contact"),
            mainuser2: mainuser2,
            billtype: localStorage.getItem("bill10type")
        }

        rawData = JSON.stringify(rawData);
        let formData = new FormData();
        formData.append('data', rawData);

        axios.post(`https://excellentdairy.com/dairy/php/cust/${landingphp}`, formData, {
            'Content-Type': 'multipart/form-data',
        }).then(function sample(response) {
            if (response.data && response.data.length > 0) {
                refprint.current.click();

                response.data && response.data.map((user, index) =>
                    setInput((prevInputSettings) => ({
                        ...prevInputSettings,
                        kno: kno,
                        kname: cname,
                        lastadv: user.lastadv,
                        lastkhadya: user.lastkhadya,
                        lastdate: lastdate
                    }))
                )
                setWait(false);
                getkhsalelatest(kno);
            }
            else {
                notifyerror(t("Khatevahi.toast.noData"));
                setDataSource([]);
                setWait(false);
            }
        }).catch(err => {
            console.log(err);
            setWait(false);
        });
    }

    const getkhsalelatest = (kno) => {
        setWait(true);

        var mainuser2 = jsEncode.encode("mamapr", 125);
        let landingphp = "getkhsalelatest.php";

        let rawData = {
            date1: input.date1,
            date2: input.date2,
            kno: kno,
            mainuser: localStorage.getItem("contact"),
            mainuser2: mainuser2,
            billtype: localStorage.getItem("bill10type")
        }

        rawData = JSON.stringify(rawData);
        let formData = new FormData();
        formData.append('data', rawData);

        axios.post(`https://excellentdairy.com/dairy/php/cust/${landingphp}`, formData, {
            'Content-Type': 'multipart/form-data',
        }).then(function sample(response) {
            if (response.data && response.data.length > 0) {
                setDataSourcekh(response.data);
                setWait(false);
            } else {
                setDataSourcekh([]);
                setWait(false);
            }
            getadvlatest(kno);
        }).catch(err => {
            setWait(false);
        });
    }

    const getadvlatest = (kno) => {
        setWait(true);

        var mainuser2 = jsEncode.encode("mamapr", 125);
        let landingphp = "getadvlatest.php";

        let rawData = {
            date1: input.date1,
            date2: input.date2,
            kno: kno,
            mainuser: localStorage.getItem("contact"),
            mainuser2: mainuser2,
            billtype: localStorage.getItem("bill10type")
        }

        rawData = JSON.stringify(rawData);
        let formData = new FormData();
        formData.append('data', rawData);

        axios.post(`https://excellentdairy.com/dairy/php/cust/${landingphp}`, formData, {
            'Content-Type': 'multipart/form-data',
        }).then(function sample(response) {
            if (response.data && response.data.length > 0) {
                setDataSourceadv(response.data);
                setWait(false);
            } else {
                setDataSourceadv([]);
                setWait(false);
            }
        }).catch(err => {
            console.log(err);
            setWait(false);
        });
    }

    var jsEncode = {
        encode: function (s, k) {
            var enc = "";
            var str = s.toString();
            for (var i = 0; i < str.length; i++) {
                var a = str.charCodeAt(i);
                var b = a ^ k;
                enc = enc + String.fromCharCode(b);
            }
            return enc;
        }
    };

    useEffect(() => {
        if (input.dno === "") {
            setInput(prevInput => ({
                ...prevInput,
                name: "",
                headname: "",
                khtype: "",
            }))
        }
        else {
            let custlisttemp = JSON.parse(localStorage.getItem("auditlist"));
            for (let i = 0; i < custlisttemp.length; i++) {
                setInput(prevInput => ({ ...prevInput, name: '' }));

                const user = custlisttemp[i];
                if (user.kno === input.dno) {
                    setInput(prevInput => ({
                        ...prevInput,
                        name: user.name,
                        headname: user.headname,
                        khtype: user.type
                    }));
                    break;
                }
            }
        }
    }, [input.dno])

    return (
        <>
            <button
                type="button"
                className="btn btn-primary"
                data-bs-toggle="modal"
                hidden={true}
                ref={refprint}
                data-bs-target="#printinput"
            >
            </button>

            <div className="sanklanmain">
                <div className="firstrowsank">
                    <img onClick={props.visibility} className='back' src={back} alt="" />
                    <div className="colmain">
                        <div className="firstrow2">
                            <div className="rowbill">
                                <>
                                    <div className="mb-2">
                                        <span className='subheadsank'>{t("Khatevahi.filters.date")}</span>
                                        <input
                                            onKeyDown={e => handleEnterKey(e, 0)}
                                            ref={ref => (inputRefs.current[0] = ref)}
                                            type="date"
                                            className="form-control"
                                            autoComplete='off'
                                            id="date1"
                                            name="date1"
                                            value={input.date1}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <span className='subheadbill'>{t("Khatevahi.filters.to")}</span>

                                    <div className="mb-2">
                                        <span className='subheadsank'>{t("Khatevahi.filters.date")}</span>
                                        <input
                                            onKeyDown={e => handleEnterKey(e, 1)}
                                            ref={ref => (inputRefs.current[1] = ref)}
                                            type="date"
                                            className="form-control"
                                            autoComplete='off'
                                            id="date2"
                                            name="date2"
                                            value={input.date2}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </>

                                <>
                                    <div className='khreportrow'>
                                        <div className="mb-2">
                                            <span className='subheadsank'>{t("Khatevahi.filters.accountNo")}</span>
                                            <input
                                                onKeyDown={e => handleEnterKey(e, 0)}
                                                ref={ref => (inputRefs.current[0] = ref)}
                                                type="number"
                                                className={"form-control"}
                                                autoComplete='off'
                                                id="dno"
                                                name="dno"
                                                value={input.dno}
                                                onChange={handleChange}
                                            />
                                        </div>

                                        <div className="mb-2 kdr">
                                            <span className='subheadsank'>
                                                {t("Khatevahi.filters.accountName")}
                                                <span className='prev'>
                                                    {" (" + input.headname + " : " + input.khtype + ")"}
                                                </span>
                                            </span>
                                            <input
                                                type="text"
                                                disabled
                                                className={"form-control"}
                                                autoComplete='off'
                                                id="name"
                                                name="name"
                                                value={input.name}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                </>

                                <div className="mb-2">
                                    {wait ? (
                                        <button
                                            ref={ref => (inputRefs.current[4] = ref)}
                                            type="submit"
                                            id='show'
                                            className="btn btn-primary mx-1 sanksmall"
                                        >
                                            {t("Khatevahi.common.loading")}
                                        </button>
                                    ) : (
                                        <button
                                            onClick={getkhpurreport}
                                            ref={ref => (inputRefs.current[4] = ref)}
                                            type="submit"
                                            id='show'
                                            className="btn btn-primary mx-1 sanksmall"
                                        >
                                            {t("Khatevahi.buttons.viewReport")}
                                        </button>
                                    )}

                                    <button
                                        onClick={showprint}
                                        ref={ref => (inputRefs.current[4] = ref)}
                                        type="submit"
                                        id='print'
                                        className="btn btn-primary mx-1 sanksmall"
                                    >
                                        {t("Khatevahi.buttons.print")}
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div className="firstrow2">
                    <div className="table-containerbill">
                        <table id="myTablebill" className="table table-bordered">
                            <thead>
                                <tr>
                                    <th className='thsmall' scope="col">{t("Khatevahi.table.date")}</th>
                                    <th className='thsmall' scope="col">{t("Khatevahi.table.particulars")}</th>
                                    <th className='thsmall' scope="col">{t("Khatevahi.table.openingBalance")}</th>
                                    <th className='thsmall' scope="col">{t("Khatevahi.table.credit")}</th>
                                    <th className='thsmall' scope="col">{t("Khatevahi.table.debit")}</th>
                                    <th className='thsmall' scope="col">{t("Khatevahi.table.balance")}</th>
                                </tr>
                            </thead>

                            <tbody>
                                {value.length > 0
                                    ? tableFilter.map((user, index) =>
                                        <tr key={index}>
                                            <td className='thsmallcustkhr'>{user.date}</td>
                                            <td className='thsmallcustkhr'>{user.remark}</td>
                                            <td className='thsmallcustkhrcredit'>{user.opening_balance}</td>
                                            <td className='thsmallcustlarge'>{user.Credit}</td>
                                            <td className='thsmallcustkhrdebit'>{user.Debit}</td>
                                            <td className='thsmallcustlarge'>{user.closing_balance}</td>
                                        </tr>
                                    )
                                    : DataSource && DataSource.map((user, index) =>
                                        <tr key={index}>
                                            <td className='thsmallcustkhr'>{user.date}</td>
                                            <td className='thsmallcustkhr'>{user.remark}</td>
                                            <td className='thsmallcustkhrcredit'>{user.opening_balance}</td>
                                            <td className='thsmallcustkhrdebit'>{user.Credit}</td>
                                            <td className='thsmallcustlarge'>{user.Debit}</td>
                                            <td className='thsmallcustlarge'>{user.closing_balance}</td>
                                        </tr>
                                    )
                                }
                            </tbody>

                            <tr style={{ backgroundColor: 'lightgray', fontWeight: 'bold' }}>
                                <td className='thsmallcust'>{t("Khatevahi.common.total")}</td>
                                <td className='thsmallcust'>{t("Khatevahi.common.dash")}</td>
                                <td className='thsmallcust'>{t("Khatevahi.common.dash")}</td>

                                <td className='thsmallcust'>
                                    {value.length > 0
                                        ? tableFilter.reduce((total, user) => total + parseFloat(user.Credit), 0).toFixed(2)
                                        : DataSource.reduce((total, user) => total + parseFloat(user.Credit), 0).toFixed(2)}
                                </td>

                                <td className='thsmallcust'>
                                    {value.length > 0
                                        ? tableFilter.reduce((total, user) => total + parseFloat(user.Debit), 0).toFixed(2)
                                        : DataSource.reduce((total, user) => total + parseFloat(user.Debit), 0).toFixed(2)}
                                </td>

                                <td className='thsmallcust'>{t("Khatevahi.common.dash")}</td>
                            </tr>

                        </table>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Khatevahi
